import React from 'react';
import QuestionLabel from './QuestionLabel';

const BigtextQuestion = ({ label, value, setValue, settings }) => {
    return (
        <label>
            <QuestionLabel label={label} settings={settings} />
            <div>
                <textarea
                    value={value}
                    onChange={e => setValue(e.target.value)}
                    className="max-w-full min-h-32"
                />
            </div>
        </label>
    );
};

export default BigtextQuestion;
